export default __webpack_public_path__ + "static/media/gallery_02.de5092ce.jpg";